// for customer signup with google
export const RESET_SIGNUP = "reset_SIGNUP";
export const SIGNUP = "SIGNUP";
export const SIGNUP_SUCCESS = "SIGNUP_success";
export const SIGNUP_FAILURE = "SIGNUP_failure";
